// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__3828I","title":"ClientInsurance_title__2aFla","itemText":"ClientInsurance_itemText__2xtrS"};